<template>
<div class="ja-plans">
  <div class="plan-box us">
    <header>
      United States
    </header>
    <FormLabel>
      <input :id="`amount${amounts[0][1]}`" type="radio" class="amount" @click="selectedAmount = amounts[0][0]" :checked="selectedAmount == amounts[0][0]"/> 
      {{amounts[0][1]}} <strong>
        <MoneyFormat class="label-amount" :value="amounts[0][0]" :currencyCode="form.currency" :hide-subunits="true" />
      </strong>   
                                   
    </FormLabel>
    <FormLabel>
      <input :id="`amount${amounts[1][1]}`" type="radio" class="amount" @click="selectedAmount = amounts[1][0]" :checked="selectedAmount == amounts[1][0]"/> 
      {{amounts[1][1]}} 
      <strong>
        <MoneyFormat class="label-amount" :value="amounts[1][0]" :currencyCode="form.currency" :hide-subunits="true" />
      </strong>                                
    </FormLabel>
    <FormLabel>
      <input :id="`amount${amounts[2][1]}`" type="radio" class="amount" @click="selectedAmount = amounts[2][0]" :checked="selectedAmount == amounts[2][0]"/> 
      {{amounts[2][1]}} 
      <strong>
        FREE
      </strong>                                
    </FormLabel>
  </div>
  <div class="plan-box canada">
    <header>
      Canada
    </header>
    <FormLabel>
      <input :id="`amount${amounts[3][1]}`" type="radio" class="amount" @click="selectedAmount = amounts[3][0]" :checked="selectedAmount == amounts[3][0]"/> 
      {{amounts[3][1]}} 
      <strong>
        <MoneyFormat class="label-amount" :value="amounts[3][0]" :currencyCode="form.currency" :hide-subunits="true" />
      </strong>                                
    </FormLabel>    
    <FormLabel>
      <input :id="`amount${amounts[4][1]}`" type="radio" class="amount" @click="selectedAmount = amounts[4][0]" :checked="selectedAmount == amounts[4][0]"/> 
      {{amounts[4][1]}} 
      <strong>
        <MoneyFormat class="label-amount" :value="amounts[4][0]" :currencyCode="form.currency" :hide-subunits="true" />
      </strong>                                
    </FormLabel>    
  </div>
  <div class="plan-box overseas">
    <header>
      Overseas
    </header>
    <FormLabel>
      <input :id="`amount${amounts[5][1]}`" type="radio" class="amount" @click="selectedAmount = amounts[5][0]" :checked="selectedAmount == amounts[5][0]"/> 
      {{amounts[5][1]}} 
      <strong>
        <MoneyFormat class="label-amount" :value="amounts[5][0]" :currencyCode="form.currency" :hide-subunits="true" />
      </strong>                                
    </FormLabel>  
    <FormLabel>
      <input :id="`amount${amounts[6][1]}`" type="radio" class="amount" @click="selectedAmount = amounts[6][0]" :checked="selectedAmount == amounts[6][0]"/> 
      {{amounts[6][1]}} 
      <strong>
        <MoneyFormat class="label-amount" :value="amounts[6][0]" :currencyCode="form.currency" :hide-subunits="true" />
      </strong>                                
    </FormLabel>  
  </div>
</div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  ref,
  watch,
  type PropType,
} from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({  setup() {
    const { setValue, form, settings } = usePaymentForm()

    const selectedAmount = ref()

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        setValue('amount', '' + selectedAmount)
      }
    })

    const amounts = computed(() => {
      const amounts = settings!.amounts!

      if (Array.isArray(amounts)) {
        return amounts
      }

      return amounts[form.value.currency || 'USD']
    })

    return {
      form,
      amounts,
      selectedAmount,
    }
  }
})
</script>
<style scoped lang="scss">
.ja-plans {
      @media (min-width: 720px) {
        display: flex;
        justify-content: space-between;
      }
}
.plan-box.us header {
    background-position: 0 0;
}
.plan-box.canada header {
    background-position: 0 -25px;
}
.plan-box.overseas header {
    background-position: 0 -50px;
}
.plan-box header {
    margin-bottom: 20px;
    font-weight: 600;
    font-size: 14px;
    height: 24px;
    display: flex;
    align-items: center;
    background-repeat: no-repeat;
    background-image: url('https://res.cloudinary.com/orthodox-union/image/upload/c_lfill,g_auto:none,q_auto,f_auto/v1468343758/JA/flags.png');
    padding-left: 34px;
}
.plan-box {
    padding: 15px 10px 15px;
    margin-bottom: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    flex: 0 0 calc(33.33% - 5px);

    label {
      font-size: 13px;
      margin-bottom: 10px;
      display: block;
    }
    strong div{
      display: inline-block
    }
}
</style>